module.exports = __webpack_public_path__ + "images/zhongduan4.jpg?v=088933ca";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/zhongduan4.jpg
 ** module id = 117
 ** module chunks = 1 2
 **/